import GroupDataDetail from './GroupDataDetail'
import enhance from './GroupDataDetail.enhancer'

export default enhance(GroupDataDetail)

export const trapColumns = [
  {
    width: 10, field: 'selectable', selectable: true, format: 'locate',
  },
  {
    width: 300, label: 'Trap Name', field: 'trapName', format: 'trapName'
  },
  {
    width: 100,
    align: 'flex-end',
    format: 'fullDate',
    field: 'lastSynced',
    label: 'Last synced', 
    helpText: 'Last time the trap was synced through the app'
  },
  {
    width: 75, label: 'Kills', field: 'totalKills', align: 'flex-end',
  },
  {
    width: 150, 
    align: 'flex-end',
    format: 'percentage',
    field: 'operatingRate',
    label: 'Operating Rate',
    helpText: 'Percentage of time trap had CO2 and Paste to perform kills'
  }
]



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataDetail/index.js